<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        title="Offerte verloren"
        :small="true"
    >
      <p>Offerte {{ payloadData.number }} markeren als verloren?</p>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="post()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    // COMPONENTS
    deanDialog,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      deanDialog,
      deanButton,
    },
  })

  export default class LoseDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: string,
    };
    public url = '/-/trade/api/quote.lost';

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public post() {
      this.$emit('setLoad', true);
      const payload = {
        id: this.payloadData.id,
      };
      axios.post(this.url, payload)
        .then(
          (response) => {
            this.$router.push({name: 'quotes'});
            this.close();
          },
          (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          },
        ).finally(() => {
        this.$emit('setLoad', false);
      });
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';
</style>
